import StarIcon from '../assets/StarIcon';

type MyComponentProps = {
	onRatingClick: (num: number) => void;
	onSubmitClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
};

const Rating: React.FC<MyComponentProps> = props => {
	const { onRatingClick, onSubmitClick } = props;
	return (
		<>
			<header>
				<div className='bg-dark-blue h-10 w-10 flex justify-center items-center rounded-full md:h-12 md:w-12'>
					<StarIcon />
				</div>
				<h1 className='font-bold text-2xl text-white mt-5 md:text-3xl md:mt-10'>
					How did we do?
				</h1>
				<p className='text-white text-sm font-normal leading-6 mt-4 md:text-base md:leading-6 md:mt-3'>
					Please let us know how we did with your support request. All feedback is
					appreciated to help us improve our offering!
				</p>
			</header>
			<form>
				<div className='flex flex-row justify-between mt-6 md:mt-5'>
					<button
						className='rating-button'
						type='button'
						onClick={() => onRatingClick(1)}
					>
						<span className='relative top-[1px] transition ease-linear duration-300'>
							1
						</span>
					</button>
					<button
						className='rating-button'
						type='button'
						onClick={() => onRatingClick(2)}
					>
						<span className='relative top-[1px] transition ease-linear duration-300'>
							2
						</span>
					</button>
					<button
						className='rating-button'
						type='button'
						onClick={() => onRatingClick(3)}
					>
						<span className='relative top-[1px] transition ease-linear duration-300'>
							3
						</span>
					</button>
					<button
						className='rating-button'
						type='button'
						onClick={() => onRatingClick(4)}
					>
						<span className='relative top-[1px] transition ease-linear duration-300'>
							4
						</span>
					</button>
					<button
						className='rating-button'
						type='button'
						onClick={() => onRatingClick(5)}
					>
						<span className='relative top-[1px] transition ease-linear duration-300'>
							5
						</span>
					</button>
				</div>
				<button
					onClick={onSubmitClick}
					className='uppercase bg-orange-custom w-full rounded-3xl py-3 text-white font-semibold leading-5 tracking-wider mt-6 transition-all ease-linear duration-300 hover:text-orange-custom hover:bg-white md:text-base md:mt-8 md:p-3'
					type='submit'
				>
					Submit
				</button>
			</form>
		</>
	);
};

export default Rating;
